/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'more': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M25 1c13.233 0 24 10.767 24 24S38.233 49 25 49 1 38.233 1 25 11.767 1 25 1zm0 2.667C13.237 3.667 3.667 13.237 3.667 25c0 11.763 9.57 21.333 21.333 21.333 11.763 0 21.333-9.57 21.333-21.333 0-11.763-9.57-21.333-21.333-21.333zM25 14.5c.83 0 1.5.67 1.5 1.5v7.5H34c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-7.5V34c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5v-7.5H16c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h7.5V16c0-.83.67-1.5 1.5-1.5z" _fill="#0D658E" fill-rule="evenodd"/>'
  }
})
